import React from "react";
import { Box, Button } from "@mui/material";
import { COLORS, TYPO } from "../../styles/uiConstants";
import { useClinicTheme } from "../../theme";
import ActionButton from "./ActionButton";

/**
 * Drawer alt footer bileşeni (CLAUDE.md "Drawer Tasarımı"):
 * İptal (outlined) + ActionButton (contained), `gap: 1.5`.
 *
 * @param {Function} onCancel - İptal fonksiyonu
 * @param {Function} onSubmit - Gönder fonksiyonu (opsiyonel, yoksa sadece cancel gösterilir)
 * @param {string} cancelLabel - İptal buton metni (varsayılan: "İptal")
 * @param {string} submitLabel - Submit buton metni
 * @param {string} loadingLabel - Yüklenirken gösterilecek metin (opsiyonel)
 * @param {boolean} loading - Yükleniyor durumu
 * @param {boolean} disabled - Submit devre dışı mı
 * @param {ReactNode} startIcon - Submit buton ikonu (opsiyonel; yoksa ActionButton varsayılanı)
 * @param {string} submitColor - Submit buton renk tipi ("primary" | "error"), varsayılan "primary"
 * @param {boolean} fullWidth - Butonlar tam genişlik mi (varsayılan false)
 */
export default function DrawerFooter({
  onCancel,
  onSubmit,
  cancelLabel = "İptal",
  submitLabel = "Kaydet",
  loadingLabel,
  loading = false,
  disabled = false,
  startIcon,
  submitColor = "primary",
  fullWidth = false,
}) {
  const { palette } = useClinicTheme();
  const isError = submitColor === "error";
  const buttonHeight = { minHeight: 40, py: 1 };

  return (
    <Box
      sx={{
        px: 3,
        py: 2,
        borderTop: `1px solid ${COLORS.slate200}`,
        display: "flex",
        gap: 1.5,
        justifyContent: fullWidth ? "stretch" : "flex-end",
        flexShrink: 0,
        bgcolor: COLORS.white,
      }}
    >
      <Button
        onClick={onCancel}
        disabled={loading}
        fullWidth={fullWidth}
        variant="outlined"
        sx={{
          ...buttonHeight,
          fontWeight: 600,
          fontSize: TYPO.body,
          textTransform: "none",
          px: 3,
          borderRadius: 2,
          color: COLORS.slate700,
          borderColor: COLORS.slate300,
          "&:hover": { borderColor: COLORS.slate400, bgcolor: COLORS.slate50 },
        }}
      >
        {cancelLabel}
      </Button>
      {onSubmit ? (
        <ActionButton
          variant={isError ? "delete" : "save"}
          palette={palette}
          size="medium"
          label={loading && loadingLabel ? loadingLabel : submitLabel}
          loading={loading}
          disabled={disabled}
          onClick={onSubmit}
          fullWidth={fullWidth}
          {...(startIcon && !loading ? { startIcon } : {})}
          sx={buttonHeight}
        />
      ) : null}
    </Box>
  );
}
